import { useContext } from 'react';
import styles from './Timeline.module.scss';
import { Context } from './context';

type TProps = {
	icon: JSX.Element;
	backgroundColor?: string;
	isLast: boolean;
	noInlinePadding?: boolean;
	lineColor?: string;
}

export const Orb = (props: TProps) => {
	const {
		icon,
		backgroundColor = 'var(--neutral-03)',
		isLast,
		noInlinePadding = false,
		lineColor
	} = props;
	const { dir } = useContext(Context);
	return <div className={`
			${dir === 'vertical' ? styles.orbContainerVert : styles.orbContainerHorz}
			${noInlinePadding && styles.orbContainerVertNoInline}
		`}>
		<div className={styles.orb} style={{ backgroundColor }}>
			{icon}
		</div>
		{!isLast && <div
			data-testid={'@Ofload-timeline-line'}
			className={dir === 'vertical' ? styles.branchVert : styles.branchHorz}
			style={{ backgroundColor: lineColor ?? backgroundColor }}
		/>}
	</div>
}
